import React, { useState } from 'react'; // Import useState for managing animation state

const AboutSection = ({ isAboutOpen, toggleAboutSection }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleToggle = () => {
    setIsAnimating(true);
    toggleAboutSection();
  };

  return (
    <div className="about-section rounded-lg shadow-md overflow-hidden">
      <button
        onClick={handleToggle}
        className="w-full px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:from-purple-700 hover:to-indigo-700 transition-all duration-200 touch-target flex justify-between items-center"
      >
        <div className="flex justify-between items-center w-full">
          <span className="text-lg font-semibold">About this Page</span>
          <span
            className="transform transition-transform duration-200"
            style={{
              transform: isAboutOpen ? 'rotate(180deg)' : 'rotate(0)',
            }}
          >
            ▼
          </span>
        </div>
      </button>
      <div
        className={`transition-[max-height] duration-300 ease-in-out overflow-hidden ${isAboutOpen ? 'max-h-[500px]' : 'max-h-0'}`} // Smooth height transition
        onTransitionEnd={() => setIsAnimating(false)}
      >
        <div className={`about-content p-4 space-y-3 bg-white bg-opacity-90 backdrop-blur-sm ${isAboutOpen || isAnimating ? 'block' : 'hidden'}`}> {/* Ensure content is always rendered */}
          <p className="text-gray-700 leading-relaxed text-sm">
            findpickleball displays Pickleball events in Brisbane using data from OpenSports.
            Click on an event to view more details.
          </p>
          <p className="text-gray-700 leading-relaxed text-sm">
            The upcoming 50 events for each Group are displayed.
            Suggestions for additional groups are welcome.
          </p>
            <p className="text-gray-700 text-sm">
              If you encounter any issues or have any feedback, please write to{' '}
              <a
                href="mailto:feedback@findpickleball.au"
                className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
              >
                feedback@findpickleball.au
              </a>
            </p>
          <div className="mt-3 pt-3 border-t border-gray-200">
            <div className="mt-2">
              <h4 className="text-xs text-gray-500 font-semibold mb-1">Add a shortcut to findpickleball:</h4>
              <ul className="text-xs text-gray-500 space-y-1">
                <li>
                  <span className="font-medium">Chrome (mobile):</span> Tap <span className="inline-block px-1 py-0.5 bg-gray-200 rounded">⋮</span> &gt; <b>Add to Home screen</b>
                </li>
                <li>
                  <span className="font-medium">Safari (mobile):</span> Tap <span className="inline-block px-1 py-0.5 bg-gray-200 rounded">Share</span> <span aria-label="Share" role="img">🔗</span> &gt; <b>Add to Home Screen</b>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Attributions Section */}
          <div className="mt-6 pt-3 border-t border-gray-200">
            <h4 className="text-xs text-gray-500 font-semibold mb-2">Attributions</h4>
            <p className="text-xs text-gray-500">
              findpickleball is made possible by amazing open-source projects and contributors.
            </p>
            <div className="flex justify-center mt-2">
              <button 
                className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-1 px-3 rounded transition-colors duration-200"
                onClick={() => {
                  // Direct call to setIsOpen in the Attributions component rather than using window function
                  if (window.setAttributionsOpen) {
                    window.setAttributionsOpen(true);
                  }
                }}
              >
                View Attributions
              </button>
            </div>
          </div>
          
          {/* PayPal Donation Section */}
          <div className="mt-6 pt-3 border-t border-gray-200">
            <h4 className="text-sm font-semibold text-gray-700 mb-2 text-center">Like findpickleball? Support the project ❤️</h4>
            <div className="flex justify-center">
              <form action="https://www.paypal.com/donate" method="post" target="_blank" rel="noopener noreferrer">
                <input type="hidden" name="business" value="TM3PVVQBKHMDL" />
                <input type="hidden" name="no_recurring" value="0" />
                <input type="hidden" name="currency_code" value="AUD" />
                <input type="image" src="https://www.paypalobjects.com/en_AU/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                {/* Removed the problematic tracking pixel */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
